import createPictogram from '../createPictogram'
import svg from './ID.svg'

export default createPictogram(svg)
